import React, { Component } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Lightbox } from 'primereact/lightbox';
import { Paginator } from 'primereact/paginator';
import { Growl } from 'primereact/growl';
import { Message } from 'primereact/message';

import servicioHttp from '../servicio/ServicioHttp';
import servicioObjetos from '../servicio/ServicioObjetos';
import servicioFormatos from '../servicio/ServicioFormatos';
import servicioArchivos from '../servicio/ServicioArchivos';
import { isIE } from '../servicio/ServicioCodificacionArchivos';
import { setTimeout } from 'core-js';
import { CALENDARIO_ES_MX, FORMATO_FECHA_CALENDAR } from '../servicio/ServicioConstantes';

const JOIN_PRINCIPAL = {
    "tcTrabajador": "alias_tcTrabajador",
    "ttLoteSolicitudIdse": "alias_ttLoteSolicitudIdse",
    "alias_ttLoteSolicitudIdse.tcEmpresa": "alias_tcEmpresa"
};
const TODOS = { label: "Todos", value: 0 };
export class ConsultaPorMovimientos extends Component {
    constructor() {
        super();
        this.state = {
            idsenube: 0,
            paginacion: {
                registrosPorPagina: 10,
                registrosTotales:0,
                join: null,
                restriccionesDinamicas: [
                ]
            },
            registrosPatronales: [],
            registroPatronal: {},
            errorRegistroPatronal: {},
            consulta: {},
            errores: {},
            iFrameSrc: null,
            mostrarCalendarios: true
        };
    }

    componentDidMount() {
        this.obtenerRegistrosPatronales();
        //this.consultaMovimientos();
    }

    consultaMovimientos = () => {
        this.asignarRestricciones();
        let { paginacion } = this.state;
        servicioHttp.consumirPostHttp('movimientos/consultar.json', paginacion).then(response => {
            this.setState({ paginacion: response.data.objeto });
        }).catch(error => {

        });
    }

    obtenerRegistrosPatronales = () => {
        servicioHttp.consumirPostHttp('empresa/obtener_registro_patronal.json').then(response => {
            let registrosPatronales = [TODOS];
            var newArray = registrosPatronales.concat(response.data.lista);
            let { consulta } = this.state;
            consulta.registroPatronal = TODOS.value;
            this.setState({ registrosPatronales: newArray, consulta: consulta });
        }).catch(error => {

        });
    };

    asigarRegistroPatronal = () => {

    }

    asignarValores = (event, mayusculas) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
    }

    realizarBusqueda = () => {
        let errores = this.validarRequeridosForm();
        let { paginacion, idsenube } = this.state;
        paginacion.numeroPagina = 0;
        idsenube = 0;
        this.setState({ idsenube: idsenube });
        if (servicioObjetos.esObjetoVacio(errores)) {
            this.asignarRestricciones();
            this.consultaMovimientos();
        }
    }

    validarRequeridosForm = () => {
        let { consulta } = this.state;
        let errores = {};
        if (!servicioObjetos.esObjetoVacio(consulta.fechaInicio) && servicioObjetos.esObjetoVacio(consulta.fechaFinal))
            errores.fechaFinal = "La fecha final es requerida";
        if (servicioObjetos.esObjetoVacio(consulta.fechaInicio) && !servicioObjetos.esObjetoVacio(consulta.fechaFinal))
            errores.fechaInicio = "La fecha inicial es requerida";
        if (!(servicioObjetos.esObjetoVacio(consulta.apPaterno) && servicioObjetos.esObjetoVacio(consulta.apMaterno) && servicioObjetos.esObjetoVacio(consulta.nombre))) {
            if (!(!servicioObjetos.esObjetoVacio(consulta.apPaterno) && !servicioObjetos.esObjetoVacio(consulta.apMaterno) && !servicioObjetos.esObjetoVacio(consulta.nombre))) {
                errores.busquedaNombre = "Debe de ingresar los siguientes datos para realizar la búsqueda: Apellido Paterno, Apellido Materno, Nombre";
                errores.apPaterno = servicioObjetos.esObjetoVacio(consulta.apPaterno);
                errores.apMaterno = servicioObjetos.esObjetoVacio(consulta.apMaterno);
                errores.nombre = servicioObjetos.esObjetoVacio(consulta.nombre);
            }
        }
        this.setState({ errores: errores });
        return errores;
    }

    asignarRestricciones = () => {
        let { consulta, paginacion, registrosPatronales } = this.state;
        paginacion.join = JOIN_PRINCIPAL;
        paginacion.restriccionesDinamicas = [];
        paginacion.ordenamientos = [];
        paginacion.ordenamientos.push({
            tipo: 'desc',
            nombrePropiedad: 'alias_ttLoteSolicitudIdse.fecha'
        });
        if (!servicioObjetos.esObjetoVacio(consulta.registroPatronal)) {
            if (consulta.registroPatronal !== 0) {
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "eq",
                    nombrePropiedad: "alias_tcEmpresa.id",
                    valorPropiedad: consulta.registroPatronal
                });
            } else {
                let empresasUsuarioSesion = [];
                for (let index = 0; index < registrosPatronales.length; index++) {
                    let elemento = registrosPatronales[index];
                    if (elemento.value !== 0) {
                        let valor = elemento.value;
                        empresasUsuarioSesion.push(
                            valor
                        );
                    }
                }
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "in",
                    nombrePropiedad: "alias_tcEmpresa.id",
                    coleccionIn: empresasUsuarioSesion
                });
            }
        }
        if (!servicioObjetos.esObjetoVacio(consulta.fechaInicio) && !servicioObjetos.esObjetoVacio(consulta.fechaFinal)) {
            let fechaIncial = servicioFormatos.formatearFechaString(consulta.fechaInicio);
            let fechaFinal = servicioFormatos.formatearFechaString(consulta.fechaFinal).replace('00:00:00', '23:59:59');
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "between",
                nombrePropiedad: "alias_ttLoteSolicitudIdse.fecha",
                valorPropiedad: null,
                fechaIncialBetween: fechaIncial,
                fechaFinalBetween: fechaFinal
            });
        }
        if (!servicioObjetos.esObjetoVacio(consulta.apPaterno) && !servicioObjetos.esObjetoVacio(consulta.apMaterno) && !servicioObjetos.esObjetoVacio(consulta.nombre)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "alias_tcTrabajador.nombre",
                valorPropiedad: consulta.nombre
            });
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "alias_tcTrabajador.primerApellido",
                valorPropiedad: consulta.apPaterno
            });
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "alias_tcTrabajador.segundoApellido",
                valorPropiedad: consulta.apMaterno
            });
        }
        if (!servicioObjetos.esObjetoVacio(consulta.lote)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "alias_ttLoteSolicitudIdse.loteIdImss",
                valorPropiedad: consulta.lote
            });
        }
        if (!servicioObjetos.esObjetoVacio(consulta.nss)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "alias_tcTrabajador.numeroSeguridadSocial",
                valorPropiedad: consulta.nss
            });
        }
    }

    reiniciarFrmBusqueda = () => {
        let consulta = {};
        consulta.registroPatronal = TODOS.value;
        this.setState({ mostrarCalendarios: false });
        this.setState({ consulta: consulta });
        setTimeout(() => {
            this.setState({ mostrarCalendarios: true });
        }, 50);
    }

    templateTipoTrabajador = (rowData, column) => {
        return servicioFormatos.formatoTipoTrabajador(rowData.tipoTrabajador);
    }

    templateTipoJornada = (rowData, column) => {
        return servicioFormatos.formatoTipoJornada(rowData.jornadaReducida);
    }
    templateTipoSalario = (rowData, column) => {
        return servicioFormatos.formatoTipoSalario(rowData.tipoSalario);
    }
    templateCausaBaja = (rowData, column) => {
        return servicioFormatos.formatoCausaBaja(rowData.causaBaja);
    }
    templateSalarioDiario = (rowData, column) => {
        return servicioFormatos.formatoSalarioDiarioIntegradoString(rowData.salarioDiarioIntegrado);
    }
    templateFechaMovimiento = (rowData, column) => {
        return servicioFormatos.formatearFechaStringIdse(rowData.fechaMovimiento);
    }

    templateEstado = (rowData, column) => {
        return servicioFormatos.filtroEstadoLote(rowData.estado);
    }

    templateError = (rowData, column) => {
        return !servicioObjetos.esObjetoVacio(rowData.descripcionError) ? rowData.descripcionError : rowData.descripcionErrorAfil;
    }

    accionBtnAcuse = (rowData) => {
        if(isIE()){
            servicioArchivos.descargaArchivo('/documentos/descarga_acuse.json', { archivoAcuseRecibo: rowData.archivoAcuseRecibo });
        }else{
            servicioArchivos.descargaArchivoComoBlob('/documentos/descarga_acuse.json', { archivoAcuseRecibo: rowData.archivoAcuseRecibo })
            .then((response) => {
                this.setState({ iFrameSrc: URL.createObjectURL(response) });
                document.getElementById("btnVisorPdfTarget").click();
            }).catch((error) => {
                this.growl.show({ severity: 'error', summary: '', detail: error });
            });
        }
       
    }

    accionBtnConstancia = (rowData) => {
        if(isIE()){
            servicioArchivos.descargaArchivo('/documentos/descarga_acuse.json', { archivoAcuseRecibo: rowData.archivoAfil });
        }else{
            servicioArchivos.descargaArchivoComoBlob('/documentos/descarga_acuse.json', { archivoAcuseRecibo: rowData.archivoAfil })
            .then((response) => {
                this.setState({ iFrameSrc: URL.createObjectURL(response) });
                document.getElementById("btnVisorPdfTarget").click();
            }).catch((error) => {                
                this.growl.show({ severity: 'error', summary: '', detail: error });
            });
        }
       
    }

    accionBtnAcuseIndividual = (rowData) => {
        if(isIE()){
            servicioArchivos.descargaArchivo('/documentos/afil_individual.json', { id: rowData.id });
        }else{
            servicioArchivos.descargaArchivoComoBlob('/documentos/afil_individual.json', { id: rowData.id })
            .then((response) => {
                this.setState({ iFrameSrc: URL.createObjectURL(response) });
                document.getElementById("btnVisorPdfTarget").click();
            }).catch((error) => {
                // console.log("error: ",error);
                this.growl.show({ severity: 'error', summary: '', detail: error });
            });
        }
        
    }

    templateOpciones = (rowData, column) => {
        return <div className="p-grid">
            <div className="p-col-12 p-md-3"><Button label="Acuse" icon="pi-md-folder" onClick={() => this.accionBtnAcuse(rowData)} /></div>
            <div className="p-col-12 p-md-4"><Button label="Constancia" icon="pi-md-folder" onClick={() => this.accionBtnConstancia(rowData)} /></div>
            <div className="p-col-12 p-md-5"><Button label="Acuse individual" icon="pi-md-folder" onClick={() => this.accionBtnAcuseIndividual(rowData)} /></div>
        </div>;
    }

    descargaExcel = () => {
        this.asignarRestricciones();
        let { paginacion } = this.state;
        servicioArchivos.descargaArchivo('/movimientos/descargar_excel.json', paginacion, this);
    }

    cambiaPagina = (event) => {
        this.asignarRestricciones();        
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ idsenube: event.first });
        this.consultaMovimientos();
    }

    columnaTipoMovimiento = (rowData, column) => {
        return servicioFormatos.formatoTipoMovimiento(rowData.tipoMovimiento);
    }

    columnaExtemporaneo = (rowData, column) => {
        return servicioFormatos.filtroExtemporaneo(rowData.extemporaneo);
    }

    columnaNss= (rowData, column) => {
        return rowData.numeroSeguridadSocial;
    }

    onIndexTemplate = (data, props) =>{
        let { idsenube }=this.state;
        return (props.rowIndex+1)+idsenube;
    }

    templateNombre = (rowData, column) => {
        return servicioFormatos.formatearNombreTrabajador(rowData);
    }

    render() {

        let { registrosPatronales, errorRegistroPatronal, consulta, errores, idsenube, paginacion,
            iFrameSrc, mostrarCalendarios } = this.state;

        const visorPdfTarget = (
            <button id="btnVisorPdfTarget" className="p-link" style={{ visibility: "hidden" }}></button>
        );

        let pieTablaExportar = <div className="p-fluid p-grid">
            <div className="p-col-12 p-md-2">
                {!servicioObjetos.esObjetoVacio(paginacion.datos) ? <Button className="p-button-secondary" type="button" onClick={this.descargaExcel} name="Excel" label="Excel" icon="pi-md-import-export" tooltip="Excel"></Button> : null}
            </div>
        </div>;

        let calendardioInicial = <div>
            <Calendar ref={(el) => this.calendario1 = el} id="consulta.fechaInicio" name="consulta.fechaInicio" value={consulta.fechaInicio || ''} onChange={(e) => this.asignarValores(e, false)} style={{ width: "100%" }} dateFormat={FORMATO_FECHA_CALENDAR} locale={CALENDARIO_ES_MX}></Calendar>
            {errores.fechaInicio ? <Message severity="error" text={errores.fechaInicio} /> : null}
        </div>;

        let calendardioFinal = <div>
            <Calendar id="consulta.fechaFinal" name="consulta.fechaFinal" value={consulta.fechaFinal || ''} onChange={(e) => this.asignarValores(e, false)} style={{ width: "100%" }} dateFormat={FORMATO_FECHA_CALENDAR} locale={CALENDARIO_ES_MX}></Calendar>
            {errores.fechaFinal ? <Message severity="error" text={errores.fechaFinal} /> : null}
        </div>;



        return (
            <div className="p-fluid">
                <Growl ref={(el) => this.growl = el} />
                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card">
                            <h1>Consulta de movimientos afiliatorios</h1>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-2">Registro Patronal:</div>
                                <div className="p-col-12 p-md-10"><Dropdown filter={true} 
                                filterPlaceholder="Filtra por RP o Nombre corto" filterBy="value,label" 
                                showClear={true}
                                appendTo={document.body} id="consulta.registroPatronal" 
                                name="consulta.registroPatronal" optionLabel="label" 
                                options={registrosPatronales} value={consulta.registroPatronal} 
                                onChange={(e) => this.asignarValores(e, false)} 
                                autoWidth={false} style={{ width: "100%" }} 
                                className={errorRegistroPatronal.error ? "p-error" : ""} /></div>
                            </div>

                            <div className="p-grid">
                                <div className="p-col-12 p-md-2">Lote:</div>
                                <div className="p-col-12 p-md-10"><InputText type="search" keyfilter="pint" maxLength="15" id="consulta.lote" name="consulta.lote" value={consulta.lote || ""} className={errores.lote ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, false) }} style={{ width: "100%" }} /></div>
                                <div className="p-col-12 p-md-2">NSS:</div>
                                <div className="p-col-12 p-md-10"><InputText type="search" keyfilter="pint" maxLength="11" id="consulta.nss" name="consulta.nss" value={consulta.nss || ""} className={errores.nss ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, false) }} style={{ width: "100%" }} /></div>
                            </div>
                            <h3>Nombre del asegurado</h3>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-1 ">Apellido Paterno:</div>
                                <div className="p-col-12 p-md-3 "><InputText type="search" id="consulta.apPaterno" name="consulta.apPaterno" value={consulta.apPaterno || ""} className={errores.apPaterno ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, false) }} style={{ width: "100%" }} /></div>
                                <div className="p-col-12 p-md-1 ">Apellido Materno:</div>
                                <div className="p-col-12 p-md-3 "><InputText type="search" id="consulta.apMaterno" name="consulta.apMaterno" value={consulta.apMaterno || ""} className={errores.apMaterno ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, false) }} style={{ width: "100%" }} /></div>
                                <div className="p-col-12 p-md-1 ">Nombre:</div>
                                <div className="p-col-12 p-md-3 "><InputText type="search" id="consulta.nombre" name="consulta.nombre" value={consulta.nombre || ""} className={errores.nombre ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, false) }} style={{ width: "100%" }} /></div>
                                <div className="p-col-12 p-md-12 ">{errores.busquedaNombre ? <Message severity="error" text={errores.busquedaNombre} /> : null}</div>
                            </div>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-4 ">Fecha de transmisión:</div>
                                <div className="p-col-12 p-md-1 ">Entre:</div>
                                <div className="p-col-12 p-md-3 ">{mostrarCalendarios ? calendardioInicial : null}</div>
                                <div className="p-col-12 p-md-1 ">y:</div>
                                <div className="p-col-12 p-md-3">{mostrarCalendarios ? calendardioFinal : null}</div>
                            </div>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-2"><Button label="Limpiar" icon="pi-md-refresh" onClick={this.reiniciarFrmBusqueda} /></div>
                                <div className="p-col-12 p-md-2"><Button label="Buscar" icon="pi-md-search" onClick={this.realizarBusqueda} /></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card">
                            <Lightbox target={visorPdfTarget}>
                                <div id="contenedorIframe"  >
                                    <iframe title="idse" id="elIframe" src={iFrameSrc} frameBorder="0" className="iframeEstilo" ></iframe>
                                </div>
                            </Lightbox>
                            <DataTable footer={pieTablaExportar} value={paginacion.datos} header="Consulta de Movimientos Afiliatorios" responsive={true} resizableColumns={true} >
                                <Column field="Index" header="Número" body={this.onIndexTemplate} style={{ width: '100px' }} autoLayout={true} resizableColumns={true}/>                                
                                <Column field="loteIdImss" header="Lote" style={{ width: '100px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="rfcEmpresa" header="RFC Patrón" style={{ width: '120px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="registroPatronal" header="Registro patronal" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.columnaNss} header="NSS" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="curp" header="CURP" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.templateNombre} header="Nombre" style={{ width: '250px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.columnaTipoMovimiento} header="Tipo Movimiento" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="tipoTrabajador" header="Tipo trabajador" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.templateTipoTrabajador} header="Tipo trabajador descripción" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="jornadaReducida" header="Tipo de jornada" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.templateTipoJornada} header="Tipo de jornada descripción" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.templateSalarioDiario} header="Salario diario integrado" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="tipoSalario" header="Tipo salario" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.templateTipoSalario} header="Tipo salario descripción" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.templateFechaMovimiento} header="Fecha movimiento" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="causaBaja" header="Causa de baja" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.templateCausaBaja} header="Causa de baja descripción" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.columnaExtemporaneo} header="Extemporaneo" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="umf" header="UMF" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="claveTrabajador" header="Cvet" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.templateEstado} header="Estado" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.templateError} header="Error" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.templateOpciones} header="Opciones" style={{ width: '500px' }} autoLayout={true} resizableColumns={true} />
                            </DataTable>
                            <Paginator first={idsenube} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina} rowsPerPageOptions={[10, 20, 40, 60, 80, 100]} template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown" currentPageReportTemplate={"Total: "+paginacion.registrosTotales+", Página ({currentPage} de {totalPages})"} />
                        </div>
                    </div>

                </div>

            </div>
        );
    };
}